import api from "../api.js";
import CustomerDetailsService from "./CustomerDetails/PosCustomerDetailsService.js";

/**
 * Point of Sale - Checkout service
 *
 * Enables PoS devices to record sales.
 */
class PosCheckoutService {

	/**
	 * Checkout an order (record its sale).
	 *
	 * @param {Integer} BasketId ID of the Basket instance to checkout
	 * @param {Array<Object>} Items Basket item objects expected in the basket
	 * @param {Array<Object>} Discounts Discounts in the basket
	 * @param {Object|null} CustomerDetails Customer details
	 * @param {Array<Object>} OrderVouchers Order voucher redemption request objects to apply
	 * @param {Object|null} QuestionAnswers Checkout question answers
	 * @param {Integer} PaymentType HOPS payment type ID to associate to order
	 * @param {Object|null} StationeryPrints Stationery print run data
	 * @param {Integer} Timestamp Unix time when PoS device created the order
	 * @param {Integer} UserId User who created the order on the PoS device
	 * @return {Promise}
	 */
	static checkout({BasketId, OfflineBasketUuid, Items, Payments, Discounts, CustomerDetails, OrderVouchers, QuestionAnswers, PaymentType, PosOffline, StationeryPrints, Timestamp, UserId}={}) {

		// Common Basket Data
		let basketData = {
			Basket: BasketId,
			OfflineBasketUuid,
			CustomerDetails: (CustomerDetails ? CustomerDetailsService.resolveItemsAllowedCustomerDetailsAnswers(Items, CustomerDetails) : null),
			Questions: QuestionAnswers,
			OrderVouchers,
			StationeryPrints,
			PaymentType,
			PosOffline,
			Timestamp,
			UserId
		};

		if (!PosOffline) {

			// Online Basket Data (UUIDs/values only)
			basketData = {
				...basketData,
				Discounts: Discounts.map(i => {
					return {
						ItemClaimUuid: i.ItemClaimUuid,
						DiscountClaimUuid: i.DiscountClaimUuid,
						DiscountAmount: i.DiscountAmount,
						DiscountQty: i.DiscountQty
					};
				}),
				Items: Items.map(i => {
					return {
						Uuid: i.Uuid,
						Price: i.Price,
						Quantity: i.Quantity
					};
				}),
				Payments: Payments.map(i => {
					return {
						PaymentProcessor: i.PaymentProcessor,
						PaymentProcessorData: i.PaymentProcessorData,
						PaymentType: i.PaymentType,
						Uuid: i.Uuid,
						Value: i.Value
					};
				})
			};

		}
		else {

			// Offline  Basket Data (Full items/payments to allow backend to add to BasketInstance)
			basketData = {
				...basketData,
				OfflineBasketUuid,
				ClientItems: Items.map(item => ({
					...item,

					/**
					 * Map the ClientItem (offline construct) on to the
					 * Item property, as the object may have different properties
					 * for online (Item) / offline (ClientItem)
					 */
					Item: item.ClientItem ? item.ClientItem : item.Item

				})),
				ClientPayments: Payments,
				Discounts
			};

		}

		return api.call({
			url: "/api/pos/checkout",
			method: "POST",
			data: basketData
		}).then(({data}) => data);

	}

}

export default PosCheckoutService;
